<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.$modal.show({
        component: () => import('./AddFacebookCampaignDialog.vue'),
        props: {
          accountId: this.accountId,
          projectId: this.projectId,
        },
        on: {
          added: () => {
            this.$emit('added');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>

<template>
  <BaseButton primary @click="openDialog"> Add Facebook Campaign </BaseButton>
</template>
